import Backdrop from "@mui/material/Backdrop";
import Spinner from "@mui/material/CircularProgress";
import { PropsWithChildren, useMemo } from "react";
import FlexBox from "../FlexBox";

type BusyBoxProps = PropsWithChildren<{
    busy: boolean;
    className?: string;
    variant?: "default" | "overlay";
    slots?: {
        loader?: React.ReactNode;
    }
}>;
export default function BusyBoxComponent({
    busy,
    children,
    className = "",
    variant = "default",
    slots = {
        loader: <Spinner />,
    }
}: BusyBoxProps) {
    // Determine container props for overlay mode
    const containerProps = useMemo(() => {
        if (variant === "overlay" && busy) {
            // Use HTML inert attribute to disable all interaction behind the overlay
            return { inert: true as unknown as boolean, "aria-busy": true } as React.HTMLAttributes<HTMLDivElement>;
        }
        return { "aria-busy": busy } as React.HTMLAttributes<HTMLDivElement>;
    }, [variant, busy]);

    const loader = slots.loader || <Spinner />;

    // Default variant: if busy, show spinner only (no children). Otherwise show children.
    if (variant === "default") {
        return <FlexBox className={className} aria-busy={busy} height="100%">
            {busy ? <div style={{ margin: "auto" }}>{loader}</div> : children}
        </FlexBox>
    }

    return <FlexBox className={className} {...containerProps} height="100%" sx={{ position: "relative" }}>
        {children}
        <Backdrop open={busy} sx={{ zIndex: t => (t.zIndex.modal + 1) }}>
            {loader}
        </Backdrop>
    </FlexBox>;
}

BusyBoxComponent.displayName = "BusyBox";